const el = document.createElement("span");
export function escapeHtml(str) {
  el.textContent = str ?? "";
  return el.innerHTML;
}
